// src/pages/Dinners.tsx

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dinnerService from "../services/DinnerService";
import { Dinner } from "../types/interfaces";
import styles from "./Dinners.module.css";
import {
  DinnerTypeLabels,
  MeatTypeLabels,
  SkillLevelLabels,
} from "../types/enums";
import { byteArrayToBase64, stringToUint8Array } from "../utils/help";

const Dinners = () => {
  const [dinners, setDinners] = useState<Dinner[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [showIdColumn, setShowIdColumn] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDinners = async () => {
      try {
        const fetchedDinners = await dinnerService.getDinners();
        setDinners(fetchedDinners);
      } catch (err) {
        setError("Failed to fetch dinners.");
      } finally {
        setLoading(false);
      }
    };

    fetchDinners();
  }, []);

  const handleToggleColumn = () => {
    setShowIdColumn(!showIdColumn);
  };

  // const editDinner = (id: string) => {
  //   navigate(`/Dinners/edit/${id}`);
  // };

  const addDinner = () => {
    navigate(`/addDinner`);
  };

  // const deleteDinner = async (id: string) => {
  //   try {
  //     const confirmed = window.confirm(
  //       "Are you sure you want to delete this dinner?",
  //     );
  //     if (confirmed) {
  //       await dinnerService.deleteDinner(id);
  //       setDinners((prevDinners) =>
  //         prevDinners.filter((dinner) => dinner.id !== id),
  //       ); // Update local state
  //     }
  //   } catch (err) {
  //     setError("Failed to delete dinner.");
  //   }
  // };

  if (loading)
    return (
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "1.5rem",
        }}
      >
        Loading... the api is eepy sleepy
      </p>
    );
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h1>måltider</h1>
      <button onClick={handleToggleColumn} className={styles.columnToggle}>
        Vis id
      </button>
      <button onClick={addDinner} className={styles.columnToggle}>
        Nytt måltid
      </button>
      <table className="table">
        <thead>
          <tr>
            <th>navn</th>
            <th>beskrivelse</th>
            <th>type</th>
            <th>kjøttype</th>
            <th>skill nivå</th>
            <th>tags</th>
            <th>bilde</th>
            {showIdColumn && <th>Id</th>}
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {dinners.map((dinner) => (
            <tr key={dinner.id}>
              <td>{dinner.name}</td>
              <td>{dinner.description}</td>
              <td>{DinnerTypeLabels[dinner.type]}</td>
              <td>{MeatTypeLabels[dinner.meatType]}</td>
              <td>{SkillLevelLabels[dinner.skillLevel]}</td>
              <td>{dinner.tags.join(", ")}</td>
              <td>
                {dinner.imageData ? (
                  <img
                    src={`data:image/jpeg;base64,${byteArrayToBase64(
                      stringToUint8Array(dinner.imageData),
                    )}`}
                    alt={dinner.name}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                ) : (
                  "No image"
                )}
              </td>
              {showIdColumn && <td>{dinner.id}</td>}
              {/* <td>
                <button onClick={() => editDinner(dinner.id)}>endre</button>
              </td> */}
              {/* <td>
                <button onClick={() => deleteDinner(dinner.id)}>
                  destruer
                </button>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Dinners;
